import { AxiosError } from 'axios';
import { put, call, takeLatest } from 'redux-saga/effects';
import { API } from '../api/base';
import { types, GetConfigAsyncRequest, Configuration } from './types';
import { getErrorCode, getErrorMessage } from 'services/api/normalizer';
import i18n from 'services/translation/i18n';

export function* getConfigAsync({ payload }: GetConfigAsyncRequest) {
  yield put({ type: types.GET_CONFIG_ASYNC.PENDING, payload: true });

  try {
    const configApi = new API('configurations');

    const config: Configuration = yield call(configApi.getOne, payload.configurationId);

    yield put({ type: types.GET_CONFIG_ASYNC.SUCCESS, payload: config });
  } catch (err) {
    const code = getErrorCode(err as AxiosError);
    const message = getErrorMessage(err as AxiosError);

    if (code === 404) {
      yield put({ type: types.GET_CONFIG_ASYNC.ERROR, payload: i18n.t('sagaError.noConfig') });
    } else {
      yield put({ type: types.GET_CONFIG_ASYNC.ERROR, payload: message });
    }
  } finally {
    yield put({ type: types.GET_CONFIG_ASYNC.PENDING, payload: false });
  }
}

export const sagas = [takeLatest(types.GET_CONFIG_ASYNC.REQUEST, getConfigAsync)];
